<template>
  <div>
      <div class="m-l-50 w-500">
        <el-form :model="pipeLine" ref="pipeLine">
          <p>WEB消息提醒</p>
          <div class="channel-content m-b-20">
            <div v-for="(item,index) in pipeLine.web">
              <el-form-item label="名称"
                :prop="'web.' + index + '.name'" 
                :rules="{required: true, message: '名称不能为空', trigger: 'blur'}">
                <el-input v-model="item.name" placeholder="请输入姓名"></el-input>
              </el-form-item>
              <el-form-item label="通道标识"
                :prop="'web.' + index + '.sign'" 
                :rules="{required: true, message: '通道标识不能为空', trigger: 'blur'}">
                <el-input v-model="item.sign" placeholder="请输入通道标识"></el-input>
              </el-form-item>
              <el-form-item label="秘钥"
                :prop="'web.' + index + '.config.secret'" 
                :rules="{required: true, message: '秘钥不能为空', trigger: 'blur'}">
                <el-input v-model="item.config.secret" placeholder="请输入秘钥"></el-input>
              </el-form-item>
              <el-form-item label="消息类型">
                <el-input v-model="item.msg_type" placeholder="请输入主题"></el-input>
              </el-form-item>
              <el-form-item label="消息主题">
                <el-select v-model="item.msg_theme" clearable placeholder="请选择">
                  <el-option
                    v-for="item in theme_list"
                    :label="item"
                    :value="item">
                  </el-option>
                </el-select>
              </el-form-item>
            </div>
          </div>

          <p>企业微信</p>
          <div class="channel-content m-b-20">
            <div class="wechat-wrap" v-for="(item,key) in pipeLine.wechat">
              <div class="m-b-10 border-b-1 w-400">
                <el-form-item label="名称" 
                  :prop="'wechat.' + key + '.name'" 
                  :rules="{required: true, message: '名称不能为空', trigger: 'blur'}">
                  <el-input v-model="item.name" placeholder="请输入企业微信姓名"></el-input>
                </el-form-item>
                <el-form-item label="通道标识" 
                  :prop="'wechat.' + key + '.sign'" 
                  :rules="{required: true, message: '通道标识不能为空', trigger: 'blur'}">
                  <el-input v-model="item.sign" placeholder="请输入企业微信通道标识"></el-input>
                </el-form-item>
                <el-form-item label="应用ID" 
                  :prop="'wechat.' + key + '.config.agent_id'" 
                  :rules="{required: true, message: '应用ID不能为空', trigger: 'blur'}">
                  <el-input v-model="item.config.agent_id" placeholder="请输入企业微信应用ID"></el-input>
                </el-form-item>
                <el-form-item label="秘钥" 
                  :prop="'wechat.' + key + '.config.secret'" 
                  :rules="{required: true, message: '秘钥不能为空', trigger: 'blur'}">
                  <el-input v-model="item.config.secret" placeholder="请输入企业微信通秘钥"></el-input>
                </el-form-item>
                  <el-form-item label="消息类型">
                  <el-input v-model="item.msg_type" placeholder="请输入主题"></el-input>
                </el-form-item>
                <el-form-item label="消息主题">
                  <el-select v-model="item.msg_theme" clearable placeholder="请选择">
                    <el-option
                      v-for="item in theme_list"
                      :label="item"
                      :value="item">
                    </el-option>
                  </el-select>
                </el-form-item>
              </div>
              <i class="el-icon-delete2" v-if="item.id" @click="delExisted(item)"></i>
              <i class="el-icon-delete2" v-else @click="delNew(key)"></i>
            </div>
            <el-button type="primary" @click="addWeChat">再添加一个企业微信应用的消息通道</el-button>
          </div>
          
          <p>消息推送IP白名单</p>
          <div class="channel-content">
            <ul class="white-list" v-if="white_list.length>0">
              <li class="m-l-10 m-b-10" v-for="(item,key) in white_list" >
                <span>{{item}}</span>
                <i class="el-icon-close" @click="delWhite(key)"></i>
              </li>
            </ul>
            <p v-else class="m-l-10 empty">目前没有IP白名单</p>
            <div class="m-b-10 ovf-hd m-l-10">
              <div class="fl w-300">
                <el-input v-model="whiteIp" placeholder="输入IP白名单"></el-input>
              </div>
              <div class="fl m-l-20">
                <el-button type="primary" @click="addIp">新增IP</el-button>
              </div>
            </div>
          </div>
           <el-button type="success" class="m-t-20" @click="save('pipeLine')">保存</el-button>
        </el-form>
      </div>
      <div class="m-l-50 m-t-30 w-650">
        <p>调用说明</p>
        <p class="line">调用接口地址：{{intro_url}}</p>
        <p class="line">调用接口类型：{{intro_method}}</p>
        <el-table
          :data="intro_params"
          border
          style="width: 100%"
          >
          <el-table-column
            prop="name"
            label="参数名"
            width="150">
          </el-table-column>
          <el-table-column
            prop="type"
            label="数据类型"
            width="150">
          </el-table-column>
          <el-table-column
            prop="intro"
            label="说明"
            width="350">
          </el-table-column>
        </el-table>
        <p class="line">例子:</p>
        <div class="channel-content m-t-10">
          <div class="line">
            <pre>{{intro_example}}</pre>
          </div>
        </div>
      </div>
  </div>
</template>
<script>
import http from '../../../assets/js/http'

export default {
  data() {
    return {
      intro_params: [],
      intro_example: '',
      intro_url: '',
      intro_method: '',
      whiteIp: '',
      dialogTableVisible: false,
      dialogFormVisible: false,
      pipeLine: {},
      web_module: [],
      wechat_module: [],
      white_list: [],
      theme_list: []
    }
  },
  methods: {
    getMsgManager() {
      this.apiGet('msg/manager').then((res) => {
        if (res.code == 200) {
          this.intro_params = res.data.intro.params
          this.intro_example = res.data.intro.example
          this.intro_url = res.data.intro.url
          this.intro_method = res.data.intro.method
          this.pipeLine = res.data.pipeline
          this.white_list = res.data.ip_white
        }
      })
    },
    addWeChat() {
      this.pipeLine.wechat.push({
        name: '',
        sign: '',
        type: 20,
        config: {
          agent_id: '',
          secret: ''
        },
        msg_type: '',
        msg_theme: ''
      })
    },
    delNew(key) {
      this.$confirm('确认要删除该【新增】消息通道?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.pipeLine.wechat.splice(key)
        _g.toastMsg(this, 'success', '成功删除该【新增】消息通道')
      })
    },
    delExisted(item) {
      this.$confirm('确认要删除该消息通道?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.apiDelete('msg/manager/', item.id).then((res) => {
          if (res.code == 200) {
            _g.toastMsg(this, 'success', '成功删除该消息通道')
            setTimeout(() => {
              _g.reloadPage(this)
            }, 1500)
          } else {
            _g.dealError(this, res)
          }
        })
      })
    },
    delWhite(key) {
      this.white_list.splice(key)
    },
    addIp() {
      if (this.whiteIp == '') {
        _g.toastMsg(this, 'error', '添加IP白名单失败,IP不能为空')
      } else {
        this.white_list.push(this.whiteIp)
        this.whiteIp = ''
      }
    },
    getTheme() {
      this.theme_list.push('无')
      this.apiGet('msg/manager/theme').then((res) => {
        if (res.code == 200) {
          this.theme_list = res.data
        }
      })
    },
    save(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          var postData = {
            ip_white: this.white_list,
            pipeline: this.pipeLine
          }
          this.apiPost('msg/manager', postData).then((res) => {
            if (res.code == 200) {
              _g.toastMsg(this, 'success', '保存成功')
              setTimeout(() => {
                _g.reloadPage(this)
              }, 1500)
            } else {
              _g.dealError(this, res)
            }
          })
        } else {
          _g.toastMsg(this, 'error', '请完善信息')
          return false
        }
      })
    }
  },
  created() {
    this.getMsgManager()
    this.getTheme()
  },
  mixins: [http]
}
</script>
<style scoped>
  .line{
    font-size:14px;
    color:#48576a;
  }
  .channel-content{
    background-color:#fff;
    padding: 20px;
    font-family: Helvetica Neue, Helvetica, PingFang SC, Hiragino Sans GB, Microsoft YaHei, SimSun, sans-ser
  }
  .empty{
    font-size:13px;
    color:#48576a;
  }
  .white-list{
    margin: 0;
    padding: 0;
  }
  .white-list li{
    font-size: 14px;
    display: inline-block;
    background-color:#eee;
    color: #666;
    padding:5px 40px 5px 10px;
    border-radius:3px;
    position:relative;
  }
  .white-list li i{
    position:absolute;
    right: 8px;
    top:8px;
    font-size: 10px;
    cursor: pointer;
  }
  .border-b-1{
    border-bottom: 1px solid #cecece;
  }
  .wechat-wrap{
    position:relative;
  }
  .wechat-wrap i{
    position: absolute;
    top: 0;
    right: 10px;
    cursor: pointer;
  }
</style>


// WEBPACK FOOTER //
// channel.vue?4e1db321